import * as React from 'react';

function SvgSpotifyMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 15.113c0 7.157 5.802 12.959 12.959 12.959 7.156 0 12.958-5.802 12.958-12.959 0-7.156-5.802-12.958-12.959-12.958C7.803 2.155 2 7.957 2 15.113zm6.51 4.767c.06-.018 6.11-1.794 11.213 1.276a.85.85 0 10.878-1.459c-5.766-3.468-12.31-1.53-12.587-1.445a.85.85 0 00.497 1.628zm12.617-2.231c-6.41-3.687-12.869-1.54-12.933-1.518a1.006 1.006 0 11-.653-1.904c.299-.102 7.395-2.459 14.589 1.678a1.006 1.006 0 01-1.003 1.744zM7.59 12.141c.076-.023 7.665-2.347 15.055 1.534a1.238 1.238 0 101.151-2.192C15.504 7.127 7.195 9.67 6.846 9.78a1.238 1.238 0 10.745 2.362z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgSpotifyMono;
